import { useState } from "react"

import { parseErrorAsObj } from "../../../../../errors/errorProcessors"
import { IAppError } from "../../../../../errors/errorTypes"
import { snackbar } from "../../../../../utils/general/generalUtils"
import { postClientProtected } from "../../../clients/clients"
import { DNO_EXPORT_MPAN } from "../../../urls/hybrid"

interface IPostExportMpanHook {
    isSending: boolean
    error: IAppError | undefined
    postExportMpan: (
        applicationId: string,
        mpan: string,
        onSuccess: () => void
    ) => Promise<void>
}

const usePostExportMpan = (): IPostExportMpanHook => {
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const postExportMpan = async (
        applicationId: string,
        exportMpan: string,
        onSuccess: () => void
    ): Promise<void> => {
        try {
            setIsSending(true)
            setError(undefined)

            const postBody = {
                applicationId,
                exportMpan,
            }

            await postClientProtected(DNO_EXPORT_MPAN, postBody)
            snackbar("Export MPAN submitted successfully", "success")
            onSuccess()
        } catch (err) {
            const appError = parseErrorAsObj(err)
            setError(appError)
            snackbar(appError.message, "error")
        } finally {
            setIsSending(false)
        }
    }

    return {
        isSending,
        error,
        postExportMpan,
    }
}

export default usePostExportMpan
